import { Grid, Skeleton, Typography } from "@mui/material";
import CustomTextFiled from "components/CustomTextField";
import AddressAutoComplete from "components/general/AddressAutoComplete";
import { FORM_VALIDATIONS } from "constants/formValidation";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { Fragment } from "react/jsx-runtime";
import { handleSnackBar } from "slices/global";
import { useAppDispatch } from "store/appHooks";
import { placeDetails } from "utils/address.util";

const OldAddressContainer = (props: any) => {
  const { control, getValues, setValue, userConfigLoading } = props;
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const addressSelected = async (e: any) => {
    if (e?.place_id) {
      const details: any = await placeDetails(e?.place_id);
      if (!details.zipcode) {
        dispatch(
          handleSnackBar({
            open: true,
            message: "Invalid address, please enter valid address.",
            severity: "error",
          })
        );
        return;
      }
      setValue("addressLine1", details.addressLine1);
      setValue("addressLine2", details.addressLine2);
      setValue("city", details.city);
      setValue("state", details.state);
      setValue("zipcode", details.zipcode);
      //   setValue("addressType", 2);
      setValue("longitude", details.longitude);
      setValue("latitude", details.latitude);
      setValue("country", details.country);
    } else {
      return;
    }
  };

  useEffect(() => {
    if (userConfigLoading) {
      setLoading(true);
    } else {
      let timeOutId: any = setTimeout(() => {
        setLoading(false);
        clearTimeout(timeOutId);
      }, 2000);
    }
  }, [userConfigLoading]);
  return loading ? (
    <Grid container spacing={2.5}>
      {[...Array(6)]?.map((el, ind: number) => (
        <Grid key={String(ind)} item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Skeleton
            variant="rectangular"
            sx={{ width: "100%", height: "40px" }}
          />
        </Grid>
      ))}
    </Grid>
  ) : (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Controller
          control={control}
          name="addressLine1"
          defaultValue=""
          rules={FORM_VALIDATIONS.REQUIRED}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <>
              <AddressAutoComplete
                onSelect={(e: any) => {
                  addressSelected(e);
                  onChange(e?.structured_formatting?.main_text ?? "");
                }}
                omitAddressFilter={false}
                CustomInput={(p: any) => {
                  return (
                    <CustomTextFiled
                      inputRef={p.InputProps.ref}
                      label="Address Line 1"
                      paramProps={p}
                    />
                  );
                }}
                defaultValue={{
                  structured_formatting: {
                    main_text: getValues()?.addressLine1 ?? "",
                    secondary_text: "",
                  },
                  description: "",
                }}
              />
              {!!error && (
                <Typography color="error" variant="caption">
                  {"Please add address." ?? ""}
                </Typography>
              )}
            </>
          )}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Controller
          control={control}
          name="addressLine2"
          defaultValue=""
          rules={FORM_VALIDATIONS.REQUIRED}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <CustomTextFiled
              showEndDropDown={false}
              inputValue={value}
              label="Address Line 2"
              onInputChange={onChange}
              showError={!!error}
              errorMessage={error?.message || " "}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Controller
          control={control}
          name="city"
          defaultValue=""
          rules={FORM_VALIDATIONS.REQUIRED}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <CustomTextFiled
              showEndDropDown={false}
              inputValue={value}
              label="city"
              onInputChange={onChange}
              showError={!!error}
              errorMessage={error?.message || " "}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Controller
          control={control}
          name="state"
          defaultValue=""
          rules={FORM_VALIDATIONS.REQUIRED}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <CustomTextFiled
              showEndDropDown={false}
              inputValue={value}
              label="state"
              onInputChange={onChange}
              showError={!!error}
              errorMessage={error?.message || " "}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Controller
          control={control}
          name="zipcode"
          defaultValue=""
          rules={FORM_VALIDATIONS.REQUIRED}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <CustomTextFiled
              showEndDropDown={false}
              inputValue={value}
              label="zipcode"
              onInputChange={onChange}
              showError={!!error}
              errorMessage={error?.message || " "}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default OldAddressContainer;
